import { render, staticRenderFns } from "./VideoSeriesItem.vue?vue&type=template&id=5645f517&scoped=true&"
import script from "./VideoSeriesItem.vue?vue&type=script&lang=js&"
export * from "./VideoSeriesItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoSeriesItem.vue?vue&type=style&index=0&id=5645f517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645f517",
  null
  
)

export default component.exports